import { render, staticRenderFns } from "./pages12.vue?vue&type=template&id=e2688f9c&scoped=true&"
import script from "./pages12.vue?vue&type=script&lang=js&"
export * from "./pages12.vue?vue&type=script&lang=js&"
import style0 from "./pages12.vue?vue&type=style&index=0&id=e2688f9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2688f9c",
  null
  
)

export default component.exports